export default "__VITE_ASSET__DSVRPuV$__"